module.exports = __webpack_public_path__ + "static/media/tick-success.ef841d58.svg";